import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import { ModelYhcKazaiDeliveryPeakSeasonRules } from './yhcDataTypes'

type PeakSeasonRuleRecord = ModelYhcKazaiDeliveryPeakSeasonRules & { id?: number }

export const yhc_kazai_delivery_peak_season_rules: ModelDef<PeakSeasonRuleRecord> = {
  tableName: 'yhc_kazai_delivery_peak_season_rules',
  tableLabel: '繁忙期シーズンルールマスタ',
  tableComment:
    '繁忙期シーズン（引越シーズン・夏季・年末等）ごとの上乗せ金額や輸送可能点数などを設定するマスタ',
  primaryKeyColType: 'NUMBER',
  columns: {
    startDate: {
      type: 'DATEONLY',
      label: '繁忙期開始日',
      replicable: true,
      validate: { notEmpty: true },
    },
    endDate: {
      type: 'DATEONLY',
      label: '繁忙期終了日',
      replicable: true,
      validate: { notEmpty: true },
    },
    additionalPrice: {
      type: 'NUMBER',
      label: '加算金額(税込)',
      replicable: true,
      validate: { notEmpty: true },
      inputAttrs: { isFormatWithComma: true },
    },
    deliverableItemCounts: {
      type: 'NUMBER',
      label: '輸送可能点数',
      replicable: true,
      setNullIfEmpty: true,
      inputHelpText:
        '1回の受注で輸送可能な点数。未入力の場合は輸送点数制限なし（注釈にも表示されません）',
    },
    additionalLeadDays: {
      type: 'NUMBER',
      label: '受注前倒し日数',
      replicable: true,
      validate: { notEmpty: true },
      inputHelpText:
        '通常期に比べてお預かりにかかる追加日数。<br>通常期と同一であれば、0 を指定してください。',
    },
    sameDayDeliveryDisabled: {
      type: 'BOOLEAN',
      label: '当日自発着利用を不可とする',
      inputHelpText: '繁忙期に当日自発着を利用不可にしたい場合はチェックを入れてください。',
    },
  },
  async beforeSave(saving) {
    const startDate = saving.startDate
    const endDate = saving.endDate

    if (startDate > endDate) {
      throw new Error('開始日～終了日の日付指定が正しくありません。')
    }

    const rules = await $core.$models.yhc_kazai_delivery_peak_season_rules.find({
      filter: {
        id: { _neq: saving.id || -1 },
      },
      limit: -1,
    })

    rules.forEach((rule) => {
      if (startDate >= rule.startDate && startDate <= rule.endDate) {
        throw new Error('設定期間が既存の期間と重複しています。')
      }
      if (endDate >= rule.startDate && endDate <= rule.endDate) {
        throw new Error('設定期間が既存の期間と重複しています。')
      }
      if (startDate <= rule.startDate && endDate >= rule.endDate) {
        throw new Error('設定期間が既存の期間と重複しています。')
      }
    })

    const deliverableItemCounts = saving.deliverableItemCounts
    if (
      deliverableItemCounts != null &&
      String(deliverableItemCounts) !== '' &&
      Number(deliverableItemCounts) <= 0
    ) {
      throw new Error(
        '輸送可能点数は1以上の整数を指定するか、未入力（無制限）としてください。',
      )
    }

    return saving
  },
}
